module.exports = __webpack_public_path__ + "img/lander_darkMode.abba454e.png";